import React from 'react';
import { Config, usePopperTooltip } from 'react-popper-tooltip';

/* adding my own little tooltip as the component library one requires refactoring to be fit for purpose. 
Its extensively so didn't want to intro that risk at the point  */
export const ToolTip = (
  props: Config & {
    content: string | React.ReactElement;
    customTrigger: React.ReactElement;
  }
) => {
  const {
    getTooltipProps,
    getArrowProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip(props);

  return (
    <>
      {React.cloneElement(props.customTrigger, {
        //@ts-ignore
        ref: setTriggerRef,
      })}
      {visible && (
        <div ref={setTooltipRef} role="tooltip" {...getTooltipProps()}>
          {props.content}
          <div {...getArrowProps()} />
        </div>
      )}
    </>
  );
};
